const hashId = (id: string | number): number => {
  const str = String(id);
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }

  return Math.abs(hash);
};

const BASE_HUES = [
  210, 60, 180, 350, 285, 330, 30, 90, 120, 230, 15, 45, 75, 150, 195, 255, 300,
  345,
] as const;

const BASE_SATURATION = 45;
const BASE_LIGHTNESS = 94;

const HUE_VARIATION = 16;
const HUE_STEPS = [-3, -2, -1, 0, 1, 2, 3] as const;

const LIGHTNESS_VARIATION = [0, -4, -8, -12, -16] as const;

export const getSharedColorByCommodityId = (id: string | number): string => {
  const hash = hashId(id);

  const baseHue = BASE_HUES[hash % BASE_HUES.length];

  const hueOffset =
    HUE_STEPS[Math.floor(hash / BASE_HUES.length) % HUE_STEPS.length] *
    HUE_VARIATION;

  const lightness =
    BASE_LIGHTNESS +
    LIGHTNESS_VARIATION[
      Math.floor(hash / (BASE_HUES.length * HUE_STEPS.length)) %
        LIGHTNESS_VARIATION.length
    ];

  const hue = (baseHue + hueOffset + 360) % 360;

  return `hsl(${Math.round(hue)}, ${BASE_SATURATION}%, ${lightness}%)`;
};
